enum ItemType {
    Employee = "Employees",
    QuickLink = "Quick Links",
    Event = "Events",
}

export default ItemType;